import { render } from "./EmployeeApplicationPromptView.vue?vue&type=template&id=574aeb52&scoped=true"
import script from "./EmployeeApplicationPromptView.vue?vue&type=script&lang=js"
export * from "./EmployeeApplicationPromptView.vue?vue&type=script&lang=js"

import "./EmployeeApplicationPromptView.vue?vue&type=style&index=0&id=574aeb52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574aeb52"]])

export default __exports__